// @ vendor
const React = require('react');
const PropTypes = require('prop-types');
const { Component } = require('react');

// @commons
const { LoadingSection } = require('commonsComponents/loadingSection');
const { EmptyState } = require('commonsComponents/emptyState');

class OKLoadingErrorMessage extends Component {

    render() {
        const { isLoading, isError, primaryTextError, iconTypeError, children } = this.props;

        if(isLoading) {
            return <LoadingSection />
        } else if (isError) {
            return (
                <EmptyState
                    primaryText={primaryTextError}
                    iconType={iconTypeError}
                />
            );
        } else if (!isLoading && !isError) {
            return children ? children : null;
        }
    }
}
OKLoadingErrorMessage.propTypes = {
    isLoading: PropTypes.bool,
    isError: PropTypes.bool,
    primaryTextError: PropTypes.string.isRequired,
    iconTypeError: PropTypes.string.isRequired,
    children: PropTypes.obj
};

OKLoadingErrorMessage.defaultProps = {
    primaryTextError: 'error',
    iconTypeError: 'noitems-banking'
}

module.exports = OKLoadingErrorMessage;